import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=15957736&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=15957736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15957736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15957736')) {
      api.createRecord('15957736', component.options)
    } else {
      api.reload('15957736', component.options)
    }
    module.hot.accept("./ActionButton.vue?vue&type=template&id=15957736&scoped=true", function () {
      api.rerender('15957736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ActionButton.vue"
export default component.exports